import { lloFetch } from '../../helpers/lloFetch';
import trans from '../../helpers/trans';
import { Skill, SkillResource } from '../@competentNL/Skills/Skills';
import { transformToSkill } from '../@competentNL/Skills/SkillsTransformers';
import { FetchResult, FetchResultType } from '../FetchResult';

export const putCandidateSkillsApiCall = async (skillIds: string[], candidateUuid: string): Promise<FetchResult<Skill[], string>> => {
    try {
        const response = await lloFetch(`/api/userCareerSkills/${candidateUuid}`, {
            method: 'PUT',
            candidateUuid,
            body: JSON.stringify(skillIds),
        });

        if (!response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const skillsResponse: SkillResource[] = await response.json();

        const skills = skillsResponse
            .map(transformToSkill)
            .filter(Boolean) as Skill[];

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: skills,
        };
    } catch (error) {
        console.error('[putCandidateSkillsApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
